<template>

  <form class="form normal entry" @submit.prevent="handleSubmit">

    <div class="left-section">

      <div>

        <Logo class="mobile" />

        <Logo :logoOverride="logo2" class="desktop" />

      </div>

    </div><div class="wrap">

      <div class="wrap-wrap">

        <div class="wrap-wrap-wrap">

      <h2 class="form-section-title" v-html="ok!==''?'Thank you for confirming your email':'Confirm your email'" />

      <p class="error" v-if="authenticationError!==''" v-html="authenticationError" />

      <router-link to="/login" v-if="ok!==''" v-html="ok" />

    </div></div></div>

  </form>

</template>

<script>
import ApiService from './../services/api.service'
import { UserService } from './../services/user.service'
import { mapMutations, mapState } from 'vuex'
import Logo from './../components/Logo.vue'
export default {
  name: "ConfirmEmail",
  components: {
    Logo
  },
  data() {
    return {
      authenticationError: '',
      ok: ''
    }
  },
  computed: {

    ...mapState('general',['logo2'])

  },
  methods: {
      ...mapMutations('general',['updateLoadingText']),
      ...mapMutations('auth',['loginSuccess']),
      handleSubmit() {}
  },
  created () {

    this.updateLoadingText('Just checking...');

    ApiService.get( 'users' + window.location.pathname, null, 'ConfirmEmail' )
    .then( function( response ) {

      this.updateLoadingText();

      if ( typeof response.data === 'object' && typeof response.data.access_token !== 'undefined' ) {

        let token = UserService.processLoginInfo(response);
        this.loginSuccess({ token: token, redirect: '/account/subscriptions' });

      }
      else {
      
        this.ok = response.data;

      }

    }.bind(this))
    .catch( function(error) {
      
      this.updateLoadingText();
      this.authenticationError = error.response.status === 404 ? 'We could not find your details, please get in touch with us.' : error.response.data.error;

    }.bind(this));

  }
};
</script>
<style lang="less" scoped>
.form.normal {

  .form-section-title {
    font-size: 26px;
  }

  .error, a {

    text-align: left;
    padding: 0;
    margin: 0;
    font-size: 16px;

  }

}
@media screen and (min-width: 1024px) {
  .form.normal {

    .form-section-title {
      font-size: 28px;
    }

    .error, a {

      font-size: 18px;

    }

  }
}
</style>